module.exports = __webpack_public_path__ + "img/ro.2eec8217.svg";